{
  "title": "الفواتير",
  "subtitle": "تُصدر من الحجز وتُرسل عبر StreamPay",
  "connection": {
    "failed": "تعذر الاتصال بـ StreamPay",
    "connected": "StreamPay متصل",
    "connectedWithReconcile": "StreamPay متصل · آخر مطابقة {{at}}"
  },
  "toast": {
    "resendCopied": "تم نسخ رابط الدفع لمشاركته مع العميل",
    "cancelled": "تم إلغاء الفاتورة",
    "retried": "تمت إعادة المحاولة",
    "linkCopied": "تم نسخ رابط الدفع"
  },
  "stats": {
    "paidThisMonth": "مدفوعة هذا الشهر",
    "awaiting": "بانتظار الدفع",
    "awaitingSub": "{{n}} فواتير",
    "pendingSend": "قيد الإرسال",
    "needsAttention": "تحتاج انتباه",
    "needsAttentionSub": "فشل الدفع أو الإرسال"
  },
  "filter": {
    "label": "تصفية الفواتير",
    "all": "الكل",
    "needsAttention": "تحتاج انتباه"
  },
  "search": {
    "label": "بحث في الفواتير",
    "placeholder": "رقم الفاتورة، رقم الحجز، العميل"
  },
  "table": {
    "caption": "الفواتير",
    "emptyTitle": "لا توجد فواتير",
    "emptyDescription": "تُصدر الفواتير من صفحة الحجز بعد تأكيده."
  },
  "columns": {
    "number": "رقم الفاتورة",
    "booking": "الحجز",
    "customer": "العميل",
    "mode": "الوضع",
    "total": "الإجمالي",
    "channels": "القنوات",
    "status": "الحالة",
    "due": "الاستحقاق"
  },
  "mode": {
    "full": "كاملة",
    "feeOnly": "رسوم فقط"
  },
  "menu": {
    "label": "إجراءات الفاتورة {{number}}",
    "viewBooking": "عرض الحجز",
    "copyLink": "نسخ رابط الدفع",
    "resend": "إعادة الإرسال",
    "cancel": "إلغاء الفاتورة",
    "cancelConfirm": "إلغاء الفاتورة {{number}}؟ لن يتمكن العميل من الدفع عبر الرابط."
  }
}
